module.exports = __webpack_public_path__ + "img/artist.207fa68d.jpg";